const footerLinkArray = [
  {
    type: 'REACT_APP_HAS_POINTSANDCASH_LINK',
    className: 'link-points-and-cash',
    dataHrefTo: '/pointsandcash',
    description: 'Pontos + dinheiro'
  },
  {
    type: 'REACT_APP_HAS_SECURITY_LINK',
    className: 'link-security',
    dataHrefTo: '/security',
    description: 'Segurança'
  },
  {
    type: 'REACT_APP_HAS_REGULATION_LINK',
    className: 'link-regulation',
    dataHrefTo: '/regulation',
    description: 'Regulamentos'
  },
  {
    type: 'REACT_APP_HAS_PRIVACY_LINK',
    className: 'link-privacy',
    dataHrefTo: '/privacy',
    description: 'Política de Privacidade'
  },
  {
    type: 'REACT_APP_HAS_TERMS_LINK',
    className: 'link-terms',
    dataHrefTo: '/terms',
    description: 'Termos de uso'
  },
  {
    type: 'REACT_APP_HAS_FAQ_LINK',
    className: 'link-faq',
    dataHrefTo: '/redirect/faq',
    description: 'Ajuda'
  },
  {
    type: 'REACT_APP_HAS_CONTACT_LINK',
    className: 'link-contact',
    dataHrefTo: '/contact',
    description: 'Fale Conosco'
  }
]

export default footerLinkArray



// WEBPACK FOOTER //
// ./src/App/Footer/FooterMenuLinks/FooterMenuLinkArrayConstant.js